import { Observable } from '../Observable';
export var EMPTY = new Observable(function (subscriber) { return subscriber.complete(); });
//# sourceMappingURL=empty.js.map